import { h } from 'preact'
import { PureComponent } from 'preact/compat'
import { baseUrl } from '../pmd/pmd-urls'

import styles from './index.module.css'

type FlightProps = {}
type FlightState = {
  position: { x: number; y: number }
  scale: number
  angle: number
}

export class Flight extends PureComponent<FlightProps, FlightState> {
  observer: any
  element: any
  isVisible: boolean

  constructor() {
    super()
    this.state = { position: { x: 0, y: 0 }, scale: 1, angle: 0 }
  }

  componentDidMount() {
    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.isVisible) {
            this.isVisible = true
            this.animate()
          }

          if (!entry.isIntersecting && this.isVisible) {
            this.isVisible = false
          }
        })
      },
      { threshold: [0] }
    )
    this.observer.observe(this.element)
  }

  animate() {
    const loop = () => {
      const { innerHeight } = window
      const halfHeight = innerHeight / 2
      const startPos = { x: 0.495, y: 0.269 }
      const endPos = { x: 0.587, y: 0.586 }
      const { top, height, width } = this.element.getBoundingClientRect()

      const length = (endPos.y - startPos.y) * height
      const startPx = startPos.y * height
      const progressPx = halfHeight - top - startPx
      const progress = Math.min(1, Math.max(0, progressPx / length))

      const heightPart = Math.sin(progress * Math.PI)

      const heightOffset = {
        x: heightPart * 30,
        y: heightPart * -30,
      }

      this.setState({
        position: {
          x: (startPos.x * (1 - progress) + progress * endPos.x) * width + heightOffset.x,
          y: (startPos.y * (1 - progress) + progress * endPos.y) * height + heightOffset.y,
        },
        scale: 0.4 + 0.1 * heightPart,
        angle: Math.tan((-width * (endPos.x - startPos.x)) / (height * (endPos.y - startPos.y))),
      })

      if (this.isVisible) {
        requestAnimationFrame(() => this.animate())
      }
    }
    loop()
  }

  render() {
    const { position, scale, angle } = this.state
    const transform = `translate3d(${Math.floor(position.x)}px, ${Math.floor(
      position.y
    )}px, 0) scale(${scale}) rotate(${angle}rad)`
    return (
      <figure
        ref={(element) => {
          this.element = element
        }}
        className={styles.flightContainer}
        alt={'Illustrasjon av flyturen'}
      >
        <img
          className={styles.flightMap}
          src={`${baseUrl}rev2/map_oslo_somalia.png`}
          alt={
            'Illustrasjon av reisen fra Norge til Somalia. Et verdenskart, hvor Norge og Somalia er fremhevet, viser ruten mellom de to landene. Et fly er tegnet inn langs denne ruten.'
          }
        />
        <div className={styles.flight} style={{ transform }}>
          <img src={`${baseUrl}rev1/fly.png`} alt="" />
        </div>
      </figure>
    )
  }
}
